export abstract class CacheWritingService {
    #cacheWriteTail = Promise.resolve()

    protected enqueueCacheWrite(write: () => Promise<void>): Promise<void> {
        const result = this.#cacheWriteTail.then(write)
        this.#cacheWriteTail = result.catch(() => undefined)
        return result
    }
}
